import React, { useState, useEffect } from 'react'

import { trackPromise } from 'react-promise-tracker'

import { GetIntroDocument } from '../../store/ContentfulClient'
import DocumentModal from '../DocumentDisplay/DocumentModal'

const HelloIntroBox = ({ user = {}, type = '' }) => {
    // const IntroPromiseArea = 'understanding-list'
    // const [document, setDocument] = useState({ title: '', description: '', url: '' })
    // useEffect(() => {
    //     const SetDocuments = () => {
    //         trackPromise(
    //             GetIntroDocument(type).then((doc) => {
    //                 if (doc) {
    //                     const {
    //                         fields: {
    //                             title,
    //                             description,
    //                             file: {
    //                                 fields: {
    //                                     file: { url },
    //                                 },
    //                             },
    //                         },
    //                     } = doc
    //                     setDocument({ title, description, url })
    //                 }
    //             }),
    //             IntroPromiseArea
    //         )
    //     }
    //     SetDocuments()
    // }, [])

    return (
        <div id="intro-box">
            {user && user.name && (
                <p>
                    <b>Hello:</b> <span>{user.name}</span>
                </p>
            )}
            {/* <div className="border-box">
                <h2>{document.title}</h2>
                <p>{document.description}</p>
                {/* <a
                    href={document.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    className="more-link"
                >
                    <span>View Video</span>
                </a> * /}
                <DocumentModal label={'View Video'} videoUrl={document.url} />
            </div> */}
        </div>
    )
}

export default HelloIntroBox
